import { Metadata } from '@redwoodjs/web'
import './App.css'

import BackToTop from './components/common/BackToTop'
import Footer from './components/common/Footer'
import Header from './components/common/Header'
import GrowBusiness from './components/custom-ui/GrowBusiness'
import CustomerPeople from './components/CustomerPeople'
import Collaborate from './components/home/Collaborate'
import CustomerIntelligence from './components/home/CustomerIntelligence'
import Hero from './components/home/Hero'
import PioneersLove from './components/home/PioneersLove'
import Pricing from './components/home/Pricing'
import ReimaginingCrm from './components/home/ReimaginingCrm'

const HomepageSpringLaunch2024Page = () => {
  return (
    <>
      <Metadata
        title="Day.ai - Reimagining CRM for the AI Age"
        description="Day.ai combines the features of a Meeting Assistant, CRM, and Knowledge Base into a single unified solution that replaces the manual, complicated interfaces of legacy CRM, and keeps you connected to what customers want."
      />
      <BackToTop />
      <Header />
      <Hero />
      <ReimaginingCrm />
      <GrowBusiness />
      <CustomerIntelligence />
      <CustomerPeople />
      <PioneersLove />
      <GrowBusiness />
      <Collaborate />
      <Pricing />
      <GrowBusiness />
      <Footer />
    </>
  )
}

export default HomepageSpringLaunch2024Page
